import { createHeadlessEditor } from "@lexical/headless";
import { createEditor, type LexicalEditor } from "lexical";
import { editorConfig } from "./editorConfig.ts";
import { editorCodeConfig } from "./editorConfigCode.ts";

// @ts-ignore
export const editor: LexicalEditor = createEditor(editorConfig);
// @ts-ignore
export const editorHeadless: LexicalEditor = createHeadlessEditor(editorConfig);

// @ts-ignore
export const editorCode: LexicalEditor = createEditor(editorCodeConfig);
// @ts-ignore
export const editorCodeHeadless: LexicalEditor = createHeadlessEditor(editorCodeConfig);
